var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.436,
    height: 23.436,
    viewBox: "0 0 23.436 23.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M10,21.718A11.718,11.718,0,1,1,21.718,33.436,11.718,11.718,0,0,1,10,21.718Zm15.134,6.963a1.247,1.247,0,0,0,0-1.764l-5.2-5.2,5.2-5.2a1.248,1.248,0,0,0-1.764-1.764l-6.08,6.08a1.247,1.247,0,0,0,0,1.764l6.08,6.08A1.247,1.247,0,0,0,25.134,28.681Z",
    transform: "translate(-10 33.436) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.2cb595ebcf6a00bca788d57843f677dc.svg";
export { ForwardRef as ReactComponent };